import { render, staticRenderFns } from "./duoResources.vue?vue&type=template&id=0ad50cd8&scoped=true&"
import script from "./duoResources.vue?vue&type=script&lang=js&"
export * from "./duoResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad50cd8",
  null
  
)

export default component.exports